module.exports = __webpack_public_path__ + "img/ic_info.b7cc18df.svg";